import { IRequestParams, IResponse } from '@dash/apiInstance';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { sendRequest } from 'src/helpers/saga';
import { executeAction } from '../../../../../../../../helpers/api';
import { logger } from '../../../../../../../../helpers/logger';
import { t } from '../../../../../../../../i18n';
import notifications from '../../../../../../../../redux/notifications/actions';
import actionTypes from './actionTypes';
import { ProcessActionRequestAction } from './actions.d';
import { IProcessActionResponse } from './types.d';
import creditsActionTypes from '../actionTypes';

function* processAction({ payload }: ProcessActionRequestAction<{}, {}>) {
  try {
    const { url, method, data, key, type, id } = payload;

    const result: IResponse<IProcessActionResponse> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      executeAction,
      { url, method, data },
      notifications.REQUEST_ERROR,
    );

    const isCreateCredit = key === 'create_credit';
    const isDeleteCredit = key === 'delete';
    const isUpdateCredit = key === 'update';

    if (result?.messages || result?.success) {
      yield put({ type: actionTypes.CHANGE_MODAL_VISIBILITY });
      yield put({ type: actionTypes.ADD_CREDIT_SUCCESS });

      if (isCreateCredit) {
        yield put({ type: creditsActionTypes.LOAD_CREDITS_REQUEST, payload: { type, id, pageSize: 9999 } });

        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.added_successfully', {
              item: t('dash.clients.unit.credit_label'),
            }),
          }),
        );
      } else if (isUpdateCredit) {
        yield put({ type: creditsActionTypes.LOAD_CREDITS_REQUEST, payload: { type, id, pageSize: 9999 } });

        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.updated_successfully', {
              item: t('dash.clients.unit.credit_label'),
            }),
          }),
        );
      } else if (isDeleteCredit) {
        yield put({ type: creditsActionTypes.LOAD_CREDITS_REQUEST, payload: { type, id, pageSize: 9999 } });

        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.removed_successfully', {
              item: t('dash.clients.unit.credit_label'),
            }),
          }),
        );
      } else {
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: result?.messages?.join(' ') || '',
          }),
        );
      }
    } else {
      if (isCreateCredit) {
        yield put({ type: actionTypes.ADD_CREDIT_ERROR, payload: { data: result } });
      }

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.something_went_wrong'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.PROCESS_ACTION_REQUEST, processAction)]);
}
